import { useNavigate } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";
import { SEO } from "utils/helmet/components/SEO";
import Button from "components/atoms/Button";
import StaticPagesHeader from "components/molecules/StaticPagesHeader";
import useTranslate from "hooks/useTranslate";
import GloryBackground from "assets/images/glory/page_404.webp";
import BangerBackground from "assets/images/banger/error_404_banger.webp";
import url from "url/index";

import "./styles.sass";

const Page404 = () => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  let backgroundImage;

  switch (VITE_APP_PROJECT_NAME) {
    case "glory":
      backgroundImage = GloryBackground;
      break;
    case "banger":
      backgroundImage = BangerBackground;
      break;
    default:
      backgroundImage = GloryBackground;
      break;
  }

  const handleClick = () => {
    navigate(makeLangUrl(url.routes.casino.index()));
  };

  return (
    <>
      <SEO pathname="/404" />
      <div className="Page404">
        <StaticPagesHeader />
        <div className="Page404__content">
          <div className="Page404__content_header">{t("error.title.404")}</div>
          <img
            src={backgroundImage}
            alt="Not_available"
            className="Page404__content_bg"
          />
          <div className="Page404__content_text">{t("error.title")}</div>
          <div className="Page404__content_button">
            <Button
              variation="primary"
              label="error.button"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Page404;
